export default "__VITE_ASSET__28ab0efc__"